import { Button, Typography } from "@mui/material";
import React from "react";
import Avatar from "../../../shared/components/Avatar";
import OnlineIndicator from "./OnlineIndicator";
import { chatTypes,getActions } from "../../../store/actions/chatActions";
import {connect} from 'react-redux';

const FriendsListItem = ({ id, username, isOnline,setChosenChatDetails }) => {
  const handleChooseActiveConversation=()=>{
    setChosenChatDetails({id:id,name:username},chatTypes.DIRECT)
  }
  return (
    <Button
    onClick={handleChooseActiveConversation}
      style={{
        width: "calc(100% - 16px)",
        height: "42px",
        margin: "4px 8px",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        textTransform: "none",
        color: "#b9bbbe",
        position: "relative",
        borderRadius: "4px",
      }}
    >
      <Avatar small username={username}  />
      <Typography
        style={{ marginLeft: "7px", fontWeight: 700, color: "#8e9297" }}
        variant="subtitle1"
        align="left"
      >
        {username}
      </Typography>
      {isOnline&&<OnlineIndicator/>}
    </Button>
  );
};
const mapActionsToProps=(dispatch)=>{
  return {
    ...getActions(dispatch),
  }
}

export default connect(null,mapActionsToProps)(FriendsListItem);
